onComplete(function () {
	// Give the fixed/sticky header a solid background once the visitor scrolls
	// past the hero, so it stays readable over the page content.
	var header = document.querySelector('.nav-header');
	if (header) {
		var onScroll = function () {
			header.classList.toggle('scrolled', window.scrollY > 200);
		};
		onScroll();
		window.addEventListener('scroll', onScroll, { passive: true });
	}

	// Fullscreen slide-up mobile menu.
	var toggle = document.querySelector('[data-nav-toggle]');
	var root = document.documentElement;
	var closeMenu = function () {
		root.classList.remove('nav-open');
		if (toggle) {
			toggle.setAttribute('aria-expanded', 'false');
			toggle.setAttribute('aria-label', toggle.getAttribute('data-label-open') || '');
		}
	};
	if (toggle) {
		toggle.addEventListener('click', function () {
			var open = root.classList.toggle('nav-open');
			toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
			toggle.setAttribute(
				'aria-label',
				(open ? toggle.getAttribute('data-label-close') : toggle.getAttribute('data-label-open')) || ''
			);
		});

		// Close when a menu link is followed or Escape is pressed.
		document.querySelectorAll('.nav-overlay a').forEach(function (link) {
			link.addEventListener('click', closeMenu);
		});
		document.addEventListener('keydown', function (event) {
			if (event.key === 'Escape') {
				closeMenu();
			}
		});
	}
});

// Scroll-reveal fade-ins. The `has-reveal` class is armed in the head before
// paint (see Config head), so the blocks below start hidden without a flash;
// here they fade up as they scroll into view.
onInteractive(function () {
	var root = document.documentElement;
	if (!root.classList.contains('has-reveal') || !('IntersectionObserver' in window)) {
		return;
	}

	var selector = '.introductie, .nieuws h2.title, .blog-item-preview, ' +
		'.blog-collection-title, .blog-item .blog-content, .blog-item .blog-related, ' +
		'.content-subtemplate-contact .row > div, .content-subtemplate-contact .contact-map, ' +
		'.content-subtemplate-content .col-12';

	// Stagger the cards within each row.
	document.querySelectorAll('.row').forEach(function (row) {
		var cards = row.querySelectorAll('.blog-item-preview');
		cards.forEach(function (card, index) {
			card.style.transitionDelay = (index % 3) * 90 + 'ms';
		});
	});

	var observer = new IntersectionObserver(function (entries) {
		entries.forEach(function (entry) {
			if (entry.isIntersecting) {
				entry.target.classList.add('is-visible');
				observer.unobserve(entry.target);
			}
		});
	}, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });

	document.querySelectorAll(selector).forEach(function (element) {
		observer.observe(element);
	});
});
